import styled from '@emotion/styled';
import React from 'react';

interface FacebookSectionProps {
	frameTitle: string;
	facebookPageId: string;
}

export const FacebookSection: React.FC<FacebookSectionProps> = ({
	facebookPageId,
	frameTitle,
}) => {
	const baseUrl = 'https://www.facebook.com/plugins/likebox.php';

	const params = new URLSearchParams({
		href: `https://www.facebook.com/${facebookPageId}/`,
		header: 'false',
		show_faces: 'true',
		stream: 'true',
		colorscheme: 'light',
		border_color: '#ffffff',
		locale: 'en_US',
	}).toString();

	return (
		<StyledFacebookFrameContainer>
			<StyledFacebookFrame title={frameTitle} src={`${baseUrl}?${params}`} />
		</StyledFacebookFrameContainer>
	);
};

const StyledFacebookFrameContainer = styled.div`
	position: relative;
	width: 100%;
	min-width: 130px;
	max-width: 300px;
	height: 539px; // From iFrame
	overflow: hidden;
`;

const StyledFacebookFrame = styled.iframe`
	height: 100%;
	border: none;
`;
